module.exports = __webpack_public_path__ + "img/line-chart-down-04.05ac48a0.svg";